'use client'

import PropTypes from 'prop-types'
import MUITypography from '@mui/material/Typography'
import MUIStack from '@mui/material/Stack'
import { ClientMatterDetailsPill } from '@repo/ui/ClientMatterDetailsPill'

export const ClientNameAndMatterDescription = ({
  clientNo,
  matterNo,
  forename,
  surname,
  matterDescription,
  //  dateArchived,
  showMatterPill = true,
  highlightIfHighRisk = false,
  sx = {}
}) => {
  if (!clientNo) return null

  const renderName = () => {
    if (!forename && !surname) return null
    if (!forename && surname) return surname
    return `${forename} ${surname}`
  }

  return (
    <MUIStack
      direction="column"
      sx={{ paddingLeft: 1, paddingRight: 1, flex: 1, width: 'calc(100% - 168px)', ...sx }}
      data-testid="clientNameAndDescription"
    >
      <MUIStack direction="row" alignItems="center" sx={{ mb: showMatterPill ? '-6px' : -1 }} gap={1}>
        {showMatterPill ? (
          <ClientMatterDetailsPill
            clientNo={clientNo}
            matterNo={matterNo}
            sx={{ height: '20px' }}
            suppressRestrictedTooltip
            highlightIfHighRisk={highlightIfHighRisk}
          />
        ) : (
          <MUITypography
            variant="body1"
            noWrap
            data-testid="clientNo"
            sx={{
              fontSize: '12px',
              color: '#666',
              pointerEvents: 'none',
              userSelect: 'none'
            }}
          >
            {clientNo}
            {matterNo ? `-${matterNo}` : ''}&nbsp;&nbsp;|&nbsp;
          </MUITypography>
        )}

        <MUITypography
          variant="body1"
          noWrap
          data-testid="clientName"
          sx={{
            fontSize: '12px',
            color: '#666',
            pointerEvents: 'none',
            userSelect: 'none',
            flex: 1
          }}
        >
          {renderName()}
        </MUITypography>
      </MUIStack>

      <MUITypography
        variant="body1"
        data-testid="matterDescription"
        sx={{
          fontSize: '14px',
          marginBottom: '0px',
          fontWeight: '600',
          pointerEvents: 'none',
          mt: showMatterPill ? 0 : -1,
          userSelect: 'none'
        }}
        noWrap
      >
        {matterDescription}
      </MUITypography>
    </MUIStack>
  )
}

ClientNameAndMatterDescription.propTypes = {
  clientNo: PropTypes.string,
  matterNo: PropTypes.any,
  forename: PropTypes.string,
  surname: PropTypes.string,
  matterDescription: PropTypes.string,
  dateArchived: PropTypes.string,
  isCurrentMatter: PropTypes.bool,
  showMatterPill: PropTypes.bool,
  highlightIfHighRisk: PropTypes.bool,
  sx: PropTypes.object
}
